import { useState, useEffect, useCallback } from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import axiosInstance from '../../../api/axios';
import dayjs from 'dayjs';
import TransactionTable from "../table/TransactionTable";
import { notifyError, notifySuccess } from "../../../components/common/toast/ToastFunc";

const TransactionHistory = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [reFetch, setReFetch] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);

  const theme = useTheme();

  const formatData = useCallback((data) => {
    try {

      const formattedData = data?.map(item => {
        return {
          ...item,
          id: item.id.replace(/-/g, ''),
          from_acc: item.from_acc.replace(/-/g, ''),
          to_acc: item.to_acc.replace(/-/g, ''),
          amount: `$ ${item.amount}`,
          created_at: dayjs(item.created_at).format('MM/DD/YYYY HH:mm:ss'), // Formatting date with dayjs
          status: item?.status.charAt(0).toUpperCase() + item?.status.slice(1).toLowerCase(),
          type: item?.type.charAt(0) + item?.type.slice(1).toLowerCase() // Capitalizing the first letter
        };
      });
      setData(formattedData);
    } catch (error) {
      notifyError("Something went wrong");
    }
  }, []);

  const reviewTransaction = useCallback(async (transaction_id) => {
    try {
      setActionLoading(true);
      const response = await axiosInstance.post('/transaction/review-transaction', { transaction_id });
      notifySuccess(response?.data?.message || "Success");
      setReFetch(!reFetch);
    } catch (error) {
      notifyError(error.message || "Something went wrong");
    } finally {
      setActionLoading(false);
    }
  }, [reFetch, setActionLoading, setReFetch]);

  const authorizeTransaction = useCallback(async (transaction_id) => {
    try {
      setActionLoading(true);
      const response = await axiosInstance.post('/auth/authorize-profile-transaction', { id: transaction_id, auth_type: "Transaction" });
      notifySuccess(response?.data?.message || "Success");
      setReFetch(!reFetch);
    } catch (error) {
      notifyError(error.message || "Something went wrong");
    } finally {
      setActionLoading(false);
    }
  }, [reFetch, setActionLoading, setReFetch]);

  useEffect(() => {
    const getData = async () => {
      try {
        setLoading(true);
        const response = await axiosInstance.get('/transaction/get-all');
        formatData(response.data.data);
      } catch (error) {
        notifyError(error.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };
    getData();
  }, [formatData, reFetch]);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", my: 3 }}>
      <Typography variant="h5" sx={{ mb: 2, color: theme.mainColor }}>Transaction History</Typography>
      <TransactionTable
        data={data}
        setData={setData}
        loading={loading}
        setReFetch={setReFetch}
        reviewTransaction={reviewTransaction}
        authorizeTransaction={authorizeTransaction}
        actionLoading={actionLoading}
      />
    </Box>
  );
};

export default TransactionHistory;
